export default {
  documents: 'Documentos',
  'documentSearch': 'Búsqueda de Documento',
};